export default "__VITE_ASSET__f74df0e4__"